import React, { useState } from 'react'
import Modal from '@material-ui/core/Modal';
import { Form } from 'reactstrap';
import {Box} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from "@material-ui/core/styles";
import '../Shared/Css/IpgoGumsa.css';

const boxStyle = {
  position: 'absolute',
  top: '68.2%',
  //left: '73.85%',
  left: '68.51%',
  transform: 'translate(-50%, -50%)',
  width: 250,
  height:230,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  //borderColor: "primary.light",
  borderColor: "red",
  boxShadow: 24,
};

const selectStyles = makeStyles(theme => ({
  formControl: {
    marginTop: theme.spacing(0.5), //셀렉트간 마진설정
    width: "10vw"
  },
  selectEmpty: {
    //marginTop: theme.spacing(0.15)
  },
  select: {
    height: "3.2vh",
    //marginTop: theme.spacing(0),
    //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  },
  inputLabel: {
    fontSize: "1.2vh",
    alignSelf: "center"
  },
}));

function IpgoGumsa(props) {
  const classes = selectStyles();
  let [balcheng, setBalcheng] = useState();
  let [youbun, setYonbun] = useState();
  let [lijung, setLijung] = useState();
  let [gongjung, setGongjung] = useState();
  let [burr, setBurr] = useState();
  
  //발청
  let balchengHandle= (e) => {
    e.preventDefault();
    setBalcheng(e.target.value);
  }
  //유분
  let youbunHandle= (e) => {
    e.preventDefault();
    setYonbun(e.target.value);
  }
  //이종품
  let lijungHandle= (e) => {
    e.preventDefault();
    setLijung(e.target.value);
  }
  //고정누락
  let gongjungHandle= (e) => {
    e.preventDefault();
    setGongjung(e.target.value);
  }
  //burr
  let burrHandle= (e) => {
    e.preventDefault();
    setBurr(e.target.value);
  }

  let gibonHandle= (e) => {
    setBalcheng('상')
    setYonbun('상')
    setLijung('무')
    setGongjung('무')
    setBurr('무')
  }
  let handleSubmit = (e) => {
    e.preventDefault();
    let gamsainsert = {
      balcheng:balcheng,
      youbun:youbun,
      lijung:lijung,
      gongjung:gongjung,
      burr:burr,
    };
    //console.log("검사항목[첫번재]")
    //console.log(gamsainsert)
    props.setGumsajahangmug(JSON.stringify(gamsainsert)) //제이슨으로 만들어전송
    props.setCustomergumsaopen(false)
  };
  

  return (
    <div>
      <Modal open={props.customergumsaopen}>
        <Box sx={boxStyle}>
          <div>
          <Form onSubmit={handleSubmit}>
              <div style={{textAlign:'center', marginTop: '12px'}}>
                <FormControl variant="outlined" className={classes.formControl} required size="small" >
                  <InputLabel variant="outlined" className={classes.inputLabel} >발청[녹]</InputLabel>
                    <Select variant="outlined" className={classes.select}
                      value={balcheng ? balcheng : ''}
                      onChange={balchengHandle}
                      label="발청[녹]"
                    >
                      <MenuItem value=''>공란<em></em></MenuItem>
                      <MenuItem value={'상'}>상</MenuItem>
                      <MenuItem value={'중'}>중</MenuItem>
                      <MenuItem value={'하'}>하</MenuItem>
                    </Select>
                </FormControl>
              </div >
              <div style={{textAlign:'center'}}>
                <FormControl variant="outlined" className={classes.formControl} required size="small" >
                  <InputLabel variant="outlined" className={classes.inputLabel}>유분,이물질잔존</InputLabel>
                    <Select variant="outlined" className={classes.select}
                      value={youbun ? youbun : ''}
                      onChange={youbunHandle}
                      label="유분,이물질잔존"
                    >
                      <MenuItem value=''>공란<em></em></MenuItem>
                      <MenuItem value={'상'}>상</MenuItem>
                      <MenuItem value={'중'}>중</MenuItem>
                      <MenuItem value={'하'}>하</MenuItem>
                    </Select>
                </FormControl>
              </div >
              <div style={{textAlign:'center'}}>
                <FormControl variant="outlined" className={classes.formControl} required size="small" >
                  <InputLabel variant="outlined" className={classes.inputLabel}>이종품혼입</InputLabel>
                    <Select variant="outlined" className={classes.select}
                      value={lijung ? lijung : ''}
                      onChange={lijungHandle}
                      label="이종품혼입"
                    >
                      <MenuItem value=''>공란<em></em></MenuItem>
                      <MenuItem value={'무'}>무</MenuItem>
                      <MenuItem value={'유'}>유</MenuItem>
                    </Select>
                </FormControl>
              </div >
              <div style={{textAlign:'center'}}>
                <FormControl variant="outlined" className={classes.formControl} required size="small" >
                  <InputLabel variant="outlined" className={classes.inputLabel}>고객공정누락</InputLabel>
                    <Select variant="outlined" className={classes.select}
                      value={gongjung ? gongjung : ''}
                      onChange={gongjungHandle}
                      label="고객공정누락"
                    >
                      <MenuItem value=''>공란<em></em></MenuItem>
                      <MenuItem value={'무'}>무</MenuItem>
                      <MenuItem value={'유'}>유</MenuItem>
                    </Select>
                </FormControl>
              </div >
              <div style={{textAlign:'center'}}>
                <FormControl variant="outlined" className={classes.formControl} required size="small" >
                  <InputLabel variant="outlined" className={classes.inputLabel}>변형,Burr,찍힘,크랙</InputLabel>
                    <Select variant="outlined" className={classes.select}
                      value={burr ? burr : ''}
                      onChange={burrHandle}
                      label="변형,Burr,찍힘,크랙"
                    >
                      <MenuItem value=''>공란<em></em></MenuItem>
                      <MenuItem value={'무'}>무</MenuItem>
                      <MenuItem value={'유'}>유</MenuItem>
                    </Select>
                </FormControl>
              </div >
              <div style={{textAlign:'center'}}>
                <button className="btn btn-success btn-sm" style={{margin:"8px 0px 0px 2px"}} type="button" onClick={gibonHandle}>기본</button>
                <button className="btn btn-primary btn-sm" style={{margin:"8px 0px 0px 2px"}} type="submit">저장</button>
                <button className="btn btn-info btn-sm" style={{margin:"8px 0px 0px 2px"}} type="button" onClick={() => {props.setCustomergumsaopen(false)}}>닫기</button>
              </div>
          </Form>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default IpgoGumsa